import type { ReactElement } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, EmptyState, Stack } from "@swot";

export function CmtsNotFoundPage(): ReactElement {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Card title="CMTS route not found">
      <Stack gap="md">
        <EmptyState title="Route not registered" message={`The requested path ${location.pathname} is not registered in the CMTS route configuration.`} />
        <div className="cmts-route-actions">
          <Button intent="button" onClick={() => navigate(-1)}>Go back</Button>
          <Button intent="button" variant="primary" onClick={() => navigate("/cmts/my-workspace", { replace: true })}>Open my workspace</Button>
        </div>
      </Stack>
    </Card>
  );
}
